import { Icon } from '@idexx-laboratories/spot-react';
import classNames from 'classnames';
import React from 'react';
import './QualificationIcon.scss';

interface QualificationIconProps {
  pass?: boolean;
  warn?: boolean;
  passTitle?: string;
  failTitle?: string;
}

const QualificationIcon = (props: QualificationIconProps): React.JSX.Element => {
  const { pass, warn, passTitle, failTitle } = props;
  return (
    <Icon
      className={classNames('qualification-icon', pass && 'pass', warn && 'warn')}
      title={
        pass ? passTitle || 'Qualified' : warn ? failTitle || 'Warning' : failTitle || 'Unqualified'
      }
      iconName={pass ? 'checkmark' : warn ? 'alert-notification' : 'cancel'}
    />
  );
};

export default QualificationIcon;
